import { Divider } from 'antd'
import type { ReactElement } from 'react'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function Section({
  title,
  description,
  children,
  isSmall,
}: {
  title: string
  description?: string
  children: ReactElement
  isSmall?: boolean
}): ReactElement {
  return (
    <div>
      <div className="mb-8 w-full">
        <p>
          {title}
          <br />
          {/* <InfoCircleOutlined className="text-xs text-gray-600 mr-1"/> */}
          {description !== undefined && <span className="text-xs text-gray-600">{description}</span>}
        </p>
        {children}
      </div>
      {isSmall !== true && <Divider />}
    </div>
  )
}
